import { Link } from "react-router-dom";

const sections = [
  {
    title: "Information collected",
    text: "When you submit an upgrade request, you may be asked for your name, contact details, delivery address and card product type. Please do not provide your full card number, CVV, PIN, online banking password or one-time password.",
  },
  {
    title: "How information is used",
    text: "Information submitted with a request is used to review that request, communicate with you and arrange delivery where an upgrade is confirmed. Additional verification may be requested when necessary.",
  },
  {
    title: "Sharing information",
    text: "Where necessary to process a confirmed request, relevant information may be shared with service providers responsible for verification, customer support or delivery. Information may also be disclosed where required by law.",
  },
  {
    title: "Security and retention",
    text: "Personal information should be retained only for as long as needed to process your request and meet applicable obligations. Avoid sending sensitive banking credentials through forms, email or customer support messages.",
  },
  {
    title: "Your privacy choices",
    text: "You may request access to or correction of information you have submitted, or ask about its deletion and the withdrawal of consent. Some information may need to be retained to meet applicable obligations.",
  },
  {
    title: "Cookies",
    text: "Your browser allows you to manage cookies and other stored website data. Blocking storage may affect features that rely on saved preferences or the progress of your request.",
  },
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#F5F6F8] font-good text-[#263B51]">
      <header className="bg-[#1e3a8a]">
        <div className="mx-auto flex h-[4.5rem] max-w-md items-center justify-between px-6">
          <Link to="/" aria-label="Home" className="flex items-center gap-2">
            <img src="/logowhite.png" alt="PNB" className="h-8 w-auto" />
            <span className="text-sm font-bold tracking-widest text-white uppercase">PNB</span>
          </Link>

          <Link
            to="/"
            aria-label="Back to home"
            className="flex h-10 w-10 items-center justify-center rounded-lg text-white/90 transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              className="h-5 w-5"
              aria-hidden="true"
            >
              <path
                d="M19 12H5M11 6l-6 6 6 6"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-md px-6 pb-10 pt-10">
        <div className="mb-5 flex items-center gap-2.5">
          <span className="h-[0.1875rem] w-4 rounded-full bg-[#1e3a8a]" />

          <span className="text-xs font-semibold uppercase tracking-widest text-[#1e3a8a]">
            Your information
          </span>
        </div>

        <h1 className="text-3xl font-semibold leading-tight tracking-tight text-[#12345A]">
          Privacy Policy
        </h1>

        <p className="mt-5 text-sm leading-relaxed text-[#748091]">
          This policy explains how information submitted with a PNB metal credit
          card upgrade request is handled and outlines your privacy choices.
        </p>

        <div className="mt-8">
          {sections.map((section) => (
            <section
              key={section.title}
              className="border-t border-[#12345A]/10 py-5"
            >
              <h2 className="text-base font-semibold text-[#12345A]">
                {section.title}
              </h2>

              <p className="mt-2 text-sm leading-relaxed text-[#748091]">
                {section.text}
              </p>
            </section>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-[#12345A]/10 pt-6 text-sm">
          <Link
            to="/"
            className="text-[#12345A] underline-offset-4 hover:underline"
          >
            Back to home
          </Link>

          <Link
            to="/terms"
            className="text-[#12345A] underline-offset-4 hover:underline"
          >
            Terms & Conditions
          </Link>
        </div>
      </main>
    </div>
  );
}